import { render, staticRenderFns } from "./SaldoContas.vue?vue&type=template&id=19da0230"
import script from "./SaldoContas.vue?vue&type=script&lang=js"
export * from "./SaldoContas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports